// Static imports
import GameIndex from '@/views/member/settings/pages/game'
import CasinoSettingsPage from '@/views/member/bet/pages/casino/settings'
import SlotSettingsPage from '@/views/member/bet/pages/slot/settings'
import SportSettingsPage from '@/views/member/bet/pages/sport/settings'
import MiniSettingsPage from '@/views/member/bet/pages/minigame/settings'

export default {
  name: 'Game',
  path: '/Game',
  component: GameIndex,
  redirect: {
    name: 'CasinoSettings'
  },
  meta: {
    layout: 'default',
    isActive: false,
    text: '게임관리',
    icon: 'icon_game',
    code: 'LV120000'
    // menuMember: true,
  },
  children: [
    {
      name: 'CasinoSettings',
      path: '/settings/game/casino',
      component: CasinoSettingsPage,
      meta: {
        menuMember: true,
        text: '카지노게임 설정관리',
        code: 'LV120100'
      }
    },
    {
      name: 'SlotSettings',
      path: '/settings/game/slot',
      component: SlotSettingsPage,
      meta: {
        menuMember: true,
        text: '슬롯게임 설정관리',
        code: 'LV120200'
      }
    },
    {
      name: 'SportSettings',
      path: '/settings/game/sport',
      component: SportSettingsPage,
      meta: {
        menuMember: true,
        text: '스포츠게임 설정관리',
        code: 'LV120300'
      }
    },
    {
      name: 'MiniSettings',
      path: '/settings/game/mini',
      component: MiniSettingsPage,
      meta: {
        menuMember: true,
        text: '미니게임 설정관리',
        code: 'LV120400'
      }
    }
  ]
}